export {
  COLUMN_LABELS_MAP,
  colLabel,
  displayLabel,
  isDefaultEnglishLabel,
  isHiddenReportColumn,
  isResultColumnKey,
  isSqlColumnKey,
  knownColumnKeys,
  resolveColumnKey,
  visibleColumnKeys,
  withPersianLabel,
} from '../../utils/columnLabels';

/** Width presets as react-grid-layout `w` (out of 12 cols) */
export const WIDTH_PRESETS = [
  { label: '¼', w: 3 },
  { label: '⅓', w: 4 },
  { label: '½', w: 6 },
  { label: '⅔', w: 8 },
  { label: '¾', w: 9 },
  { label: '١٢/١٢', w: 12 },
];

/** Height presets as react-grid-layout `h` units (shared with viewer row height). */
export const HEIGHT_PRESETS = [
  { label: 'کوچک',    h: 3  },
  { label: 'متوسط',   h: 5  },
  { label: 'بزرگ',    h: 7  },
  { label: 'خیلی بزرگ', h: 10 },
];

export const LEVEL_LABELS = {
  1: 'فروشنده', 2: 'سرپرست', 3: 'رییس فروش', 4: 'مدیر شعبه/مرکز',
};

/** @deprecated Prefer per-job configs via job_{id}_reports */
export const ROLE_KEYS = {
  seller:     'seller_reports',
  supervisor: 'supervisor_reports',
  saleoffice: 'saleoffice_reports',
  center:     'center_reports',
  admin:      'admin_reports',
  ceo:        'ceo_reports',
};

/** @deprecated Designer now lists settings.job */
export const ROLE_LABELS = {
  seller:     'فروشنده',
  supervisor: 'سرپرست',
  saleoffice: 'رییس فروش',
  center:     'مدیر شعبه',
  admin:      'مدیر سیستم',
  ceo:        'مدیر ارشد',
};

/** @deprecated Use job.level_type instead */
export const ROLE_MAX_LEVEL = {
  seller: 1, supervisor: 2, saleoffice: 3,
  center: 4, admin: 4, ceo: 4,
};

function uuidFromGetRandomValues() {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** New reports/tabs/widgets only. Existing saved short ids are left unchanged. */
export function genId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    return uuidFromGetRandomValues();
  }
  throw new Error('crypto.randomUUID is not available');
}
